module.exports = __webpack_public_path__ + "img/construction_management_2_splash.9403f44a.jpg";